const truncateFirstname = (name) => `${name.split(' ')[0].slice(0, 1)}. ${name.split(' ').slice(-1)}`;

export default truncateFirstname;
